// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "ser-mais-criativo.firebaseapp.com",
  "projectId": "ser-mais-criativo",
  "storageBucket": "ser-mais-criativo.appspot.com",
  "messagingSenderId": "990764038028",
  "appId": "1:990764038028:web:f05a091d10325a07ad48a9",
  "measurementId": "G-L5H35YK6NP",
  "apiKey": "AIzaSyDTfPWQW8Nx2N9cBXVJwxhjRx6LzQIfDUg"
};
